import React, { useEffect, useRef, useState } from "react";
import { Button, Icon } from "../../Elements";
import Debounce from "../../Elements/Textboxs/Debounce";

const Audio: React.FC<FileInterface> = ({
    fileName,
    fileAddress,
    className,
    isLoading
}) => {
    const audioElement = useRef<HTMLAudioElement>(null)
    const [isPlay, setIsPlay] = useState<boolean>(false);
    const [isProgressDownload, setIsProgressDownload] = useState<boolean>(false);
    const [time, setTime] = useState<{ duration: number, currentTime: number }>({ currentTime: 0, duration: 0 });
    function updateTrackTime(track: React.SyntheticEvent<HTMLAudioElement, Event>) {
        var currTime = Math.floor(track.currentTarget.currentTime);
        var duration = Math.floor(track.currentTarget.duration);

        if (isNaN(duration) || isNaN(currTime)) {
            setTime({ currentTime: 0, duration: 0 });
        }
        else {
            setTime({ currentTime: currTime, duration: duration });
        }
    }

    const goToTimeOfAudio = (currentTime: number) => {
        if (audioElement.current) {
            setIsPlay(false)
            audioElement.current?.pause()
            setTime({ ...time, currentTime: currentTime })
            audioElement.current!.currentTime = currentTime

            Debounce({
                func: () => {
                    setIsPlay(true)
                },
                timeout: 200
            })

        }
    }
    useEffect(() => {
        if (audioElement.current) {
            if (isPlay) {
                setIsProgressDownload(true)
                audioElement.current?.play().finally(() => {
                    setIsProgressDownload(false)
                })
            }
            else if (!isProgressDownload)
                audioElement.current?.pause()
        }
    }, [isPlay])
    // useEffect(() => {
    //     if (audioElement.current) {
    //         const progress = (e) => {
    //             setIsProgressDownload(true)
    //         }

    //         audioElement.current.addEventListener('progress', progress)
    //         audioElement.current.addEventListener('canplaythrough', () => {

    //             setIsProgressDownload(false)
    //             audioElement.current?.removeEventListener('progress', progress)
    //         })
    //     }
    // }, [audioElement])
    return <>
        <audio preload="none" autoPlay={false} src={fileAddress} ref={audioElement} className="hidden" onTimeUpdate={updateTrackTime} />

        <div className={`${className || ''} bg-disable px-2 py-1 rounded-xl relative`}>
            <span className="text-xs">{fileName.split('.')[0].shortText(50)}</span>
            <div className="w-full flex justify-center items-center gap-2 h-14">
                <input type="range" className="accent-primaryLight w-[80%] h-1" style={{ direction: 'ltr' }} value={time.currentTime} max={time.duration} onChange={(e) => {
                    e.preventDefault()
                    const currentTime = parseInt(e.target.value);
                    goToTimeOfAudio(currentTime)
                }} />
                <Button disabled={isLoading} className={`!rounded-full !relative bg-primary !p-0 !outline-none !border-none w-[13%] aspect-square `}
                    onClick={() => {
                        if (!isProgressDownload)
                            setIsPlay(!isPlay)

                    }}>
                    {isProgressDownload ?
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" fill="#FFFFFF" stroke="#FFFFFF" className="animate-spin w-7 h-7">

                            <g id="SVGRepo_bgCarrier" stroke-width="0" />

                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

                            <g id="SVGRepo_iconCarrier">

                                <path fill="#FFFFFF" d="M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32zm0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32zm448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32zm-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32zM195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0zm-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z" />

                            </g>

                        </svg>
                        : <Icon icon={`${isPlay ? 'rayteb-pause' : 'rayteb-play'}`} className={`text-white text-2xl relative ${isPlay ? '' : 'pl-[2px] pt-[2px]'}`} />}

                </Button>
                <div className="absolute bottom-0 right-4">
                    <span className="text-xs">{`${formatSecondsAsTime(time.duration, 'mm:ss')} / ${formatSecondsAsTime(time.currentTime, 'mm:ss')} `}</span>
                </div>
            </div>
        </div>
    </>
}

export default Audio;

const formatSecondsAsTime = (secs, format) => {
    var hr = Math.floor(secs / 3600).toString();
    var min = Math.floor((secs - (parseInt(hr) * 3600)) / 60).toString();
    var sec = Math.floor(secs - (parseInt(hr) * 3600) - (parseInt(min) * 60)).toString();

    if (parseInt(hr) < 10) { hr = "0" + hr; }
    if (parseInt(min) < 10) { min = "0" + min; }
    if (parseInt(sec) < 10) { sec = "0" + sec; }
    if (hr) { hr = "00"; }

    if (format != null) {
        var formatted_time = format.replace('hh', hr);
        formatted_time = formatted_time.replace('h', parseInt(hr) * 1 + ""); // check for single hour formatting
        formatted_time = formatted_time.replace('mm', min);
        formatted_time = formatted_time.replace('m', parseInt(min) * 1 + ""); // check for single minute formatting
        formatted_time = formatted_time.replace('ss', sec);
        formatted_time = formatted_time.replace('s', parseInt(sec) * 1 + ""); // check for single second formatting
        return formatted_time;
    } else {
        return hr + ':' + min + ':' + sec;
    }
}